import React from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Login from "./pages/Login";
import NewExecutivePage from "./pages/newexecutive/NewExecutivePage";
import Sidebar from "./components/sidebar/Sidebar";
import ViewExecutivePage from "./pages/viewexecutive/ViewExecutivePage";
import ViewCustomerPage from "./pages/viewcustomer/ViewCustomerPage";
import ViewPurchasePage from "./pages/viewpurchase/ViewPurchasePage";
import ViewProductPage from "./pages/viewproduct/ViewProductPage";
import ViewOrderPage from "./pages/vieworder/ViewOrderPage";
import AddProductPage from "./pages/addproduct/AddProductPage";
import NewpurchasePage from "./pages/newpurchase/NewpurchasePage";
import NewCustomer from "./components/customers/NewCustomer";
import NewCustomerPage from "./pages/newcustomer/NewCustomerPage";
import NewOrderPage from "./pages/neworder/NewOrderPage";
import DashboardPage from "./pages/dashboard/DashboardPage";
import OrderInvoicePage from "./pages/invoicescreens/OrderInvoicePage";
import Invoice from "./components/invoices/Invoice";
import ProfilePage from "./pages/profile/ProfilePage";
import ProductOutInvoicePage from "./pages/invoices/ProductOutInvoicePage";
import OverAllReportDownload from "./components/invoices/OverAllReportDownload";
import SalesPage from "./pages/report/SalesPage";
import PurchasePage from "./pages/report/PurchasePage";
import ProductPage from "./pages/report/ProductPage";

import ViewIncentivePage from "./pages/viewincentive/ViewIncentivePage";
import IncentivePage from "./pages/report/IncentivePage";

const Navigation = () => {
  const location = useLocation();
  const logintrue = sessionStorage.getItem("login");
  const isLoggedIn = !!logintrue;
  let role = sessionStorage.getItem("rolebase");
  const showSidebar = isLoggedIn;
  return (
    <>
      <section className="bajajMainSection">
        {showSidebar ? (
          <>
            <Sidebar />
            <div className="routing_head_block">
              {role == "admin" && (
                <>
                  <Routes>
                    <Route path="/" element={<DashboardPage />} />
                    <Route
                      path="/newExecutive"
                      element={<NewExecutivePage />}
                    />
                    <Route
                      path="/viewExecutive"
                      element={<ViewExecutivePage />}
                    />
                    <Route
                      path="/viewCustomer"
                      element={<ViewCustomerPage />}
                    />
                    <Route path="/newCustomer" element={<NewCustomerPage />} />
                    <Route
                      path="/viewPurchase"
                      element={<ViewPurchasePage />}
                    />
                    <Route path="/viewProduct" element={<ViewProductPage />} />

                    <Route path="/addProduct" element={<AddProductPage />} />
                    <Route path="/newPurchase" element={<NewpurchasePage />} />

                    <Route path="/newOrder" element={<NewOrderPage />} />
                    <Route path="/viewOrder" element={<ViewOrderPage />} />
                    <Route
                      path="/orderInvoice"
                      element={<OrderInvoicePage />}
                    />
                    <Route
                      path="/productInvoice"
                      element={<ProductOutInvoicePage />}
                    />
                    <Route path="/invoice" element={<Invoice />} />
                    <Route path="/profile" element={<ProfilePage />} />
                    <Route
                      path="/overallBillReport"
                      element={<OverAllReportDownload />}
                    />
                    <Route path="/salesReport" element={<SalesPage />} />
                    <Route path="/purchaseReport" element={<PurchasePage />} />
                    <Route path="/productReport" element={<ProductPage />} />
                    <Route
                      path="/incentiveView"
                      element={<ViewIncentivePage />}
                    />
                    <Route
                      path="/incentiveReport"
                      element={<IncentivePage />}
                    />

                    <Route path="*" element={<DashboardPage />} />
                  </Routes>
                </>
              )}
              {role == "Sales" && (
                <>
                  <Routes>
                    <Route path="/" element={<ViewOrderPage />} />
                    <Route path="/newOrder" element={<NewOrderPage />} />

                    <Route
                      path="/viewCustomer"
                      element={<ViewCustomerPage />}
                    />
                    <Route path="/newCustomer" element={<NewCustomerPage />} />
                    <Route path="/viewProduct" element={<ViewProductPage />} />

                    <Route path="/addProduct" element={<AddProductPage />} />
                    <Route
                      path="/orderInvoice"
                      element={<OrderInvoicePage />}
                    />
                    <Route
                      path="/productInvoice"
                      element={<ProductOutInvoicePage />}
                    />
                    <Route path="/invoice" element={<Invoice />} />
                    <Route
                      path="/overallBillReport"
                      element={<OverAllReportDownload />}
                    />
                  </Routes>
                </>
              )}
            </div>
          </>
        ) : (
          <>
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="*" element={<Login />} />
            </Routes>
          </>
        )}
      </section>
    </>
  );
};

export default Navigation;
